import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'

import useStyles from './useStyles'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { BoxDetails } from './Boxes/Details'
import BreadcrumbsComponent from '../Breadcrumbs/Breadcrumbs'
import { verifyBasicVersionStatus } from '../../../redux/actions/Instances'
import RuleIcon from '@mui/icons-material/Rule'
import { UsersDetails } from './Boxes/UsersDetails'
import { getOrganizationWithID } from '../../../redux/actions/Organizations'
export const VerifyStateME = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [dataprocess, setdataprocess] = useState(null)
  const [organization, setOrganization] = useState(null)

  const getOrganization = async () => {
    const getOrg = await dispatch(getOrganizationWithID(id))
    if (getOrg) {
      setOrganization(getOrg)
    }
  }

  const getDataProcess = async () => {
    setLoading(true)
    const verifyResponse = await dispatch(verifyBasicVersionStatus(id))
    setdataprocess(verifyResponse)
    setLoading(false)
  }

  useEffect(async () => {
    if (id) {
      await getDataProcess()
      await getOrganization()
    }
  }, [])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent
        name={organization ? organization.organizationName : ''}
      />

      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Estado de Inicialización de Mi Estudio Versión Básico
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <RuleIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar los detalles sobre el estado de
          inicialización de la aplicación Mi Estudio en su versión básica
          asociada a la organización
        </Typography>
      </div>
      {dataprocess && (
        <>
          <BoxDetails dataprocess={dataprocess} organization={organization} />
          <UsersDetails dataprocess={dataprocess} />
        </>
      )}
    </div>
  )
}
